<template>
  <div class="flex flex-col sm:flex-row h-full min-h-0 relative">
    <router-view class="min-w-0 flex-1 min-h-0 overflow-hidden order-1 sm:order-2" />
    <div
      v-if="hasReservationSubscription"
      class="w-full sm:w-auto sm:h-full sm:max-h-none bg-sidebar-background/50 flex flex-row sm:flex-col items-center justify-evenly sm:justify-start px-2 sm:px-2 pt-2 pb-[calc(8px+var(--safe-area-inset-bottom,0px))] sm:py-4 gap-4 sm:gap-2 order-2 sm:order-1"
    >
      <router-link :to="{ name: 'reservationsList' }" v-slot="{ isActive, navigate }">
        <l-tooltip :placement="'right'" :disabled="isMobile">
          <div
            :class="[
              'flex flex-col sm:grid sm:place-content-center items-center justify-center gap-[2px] sm:gap-0 w-[76px] sm:w-[44px] h-[44px] px-0 sm:p-2 rounded-[12px] transition-colors',
              isActive ? 'bg-v-300' : ''
            ]"
            @click="navigate()"
          >
            <l-icon name="lucide/calendar-check-2" size="medium" />
            <span class="text-[8px] uppercase leading-tight sm:hidden">
              {{ t('reservations.list') }}
            </span>
          </div>
          <template #content>
            {{ t('reservations.list') }}
          </template>
        </l-tooltip>
      </router-link>
      <router-link :to="{ name: 'reservationsTimeline' }" v-slot="{ isActive, navigate }">
        <l-tooltip :placement="'right'" :disabled="isMobile">
          <div
            :class="[
              'flex flex-col sm:grid sm:place-content-center items-center justify-center gap-[2px] sm:gap-0 w-[76px] sm:w-[44px] h-[44px] px-0 sm:p-2 rounded-[12px] transition-colors',
              isActive ? 'bg-v-300' : ''
            ]"
            @click="navigate()"
          >
            <l-icon name="lucide/align-start-vertical" size="medium" />
            <span class="text-[8px] uppercase leading-tight sm:hidden">
              {{ t('reservations.timeline') }}
            </span>
          </div>
          <template #content>
            {{ t('reservations.timeline') }}
          </template>
        </l-tooltip>
      </router-link>
    </div>
  </div>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { useI18n } from 'vue-i18n'

import { LIcon, LTooltip } from '@last/core-ui/paprika'

import { useAuthStore } from '@/store/auth'
import { isMobile } from '@/utils/device-type'

const { t } = useI18n()
const authStore = useAuthStore()

const { hasReservationSubscription } = storeToRefs(authStore)
</script>
